import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import isEmpty from "lodash/isEmpty";

// Components
import Loader from '../../../utils/Loader';
import Select from 'react-select';
import AdminTopTierProductsEdit from './AdminTopTierProductsEdit';

import { loadTopTiers } from '../../../../store/actions/topTier';
import { addRoute } from '../../../../store/actions/route';
import { setpageTitle } from '../../../../store/actions/siteInfo'

class AdminTopTierProducts extends Component{
    constructor(props){
        super(props)
        this.state = {
            topTierSelected: {},
            topTierIndex: null,
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Top Tier Products')
    }

    componentDidMount(){
        this.props.loadTopTiers();
    }

    handleSelectBoxChange = (id) => {
        this.setState({   
            topTierIndex: id,
            topTierSelected: this.props.topTiers[id],
        }, 
        () => { this.props.loadTopTiers() });
    }

    reloadTopTiers = () => {
        this.props.loadTopTiers();
    }

    render(){
        const { topTierSelected, topTierIndex } = this.state;
        const { topTiers, topTiersLoading } = this.props;

        // Select Box Values
        const topTierOptions = [];
        let i = 0;
        !isEmpty(topTiers) && topTiers.forEach(element => {
            topTierOptions.push({value: i++, label: element.name});
        })

        return (
            <Fragment>
                <h1>Top Tier Products</h1>
                <div className="instruction">Top Tiers can be assigned products which will be discounted for all eligible customers if a discount is currently set for that top tier. <br/>If no products have been selected, then ALL products on the site will be discounted. To ignore this, simply remove the discount value from that top tier.</div>

                {/* Loading */
                topTiersLoading ? 
                <div className="pt2 pb2">
                    <Loader />
                </div> :
                /* Page Content */
                <Fragment>
                    {!!topTiers && topTiers.length <= 0 ? <div>There are currently no top tiers to display.</div> :
                    <Fragment>
                        {/* Top Tier Select Box */}
                        <div className="tt-prod-select">
                            <div className="tt-prod-select-label">Select Top Tier:</div>
                            <Select className="select-box" 
                                name={`top_tier_id`} 
                                value={topTierIndex} 
                                onChange={selection => this.handleSelectBoxChange(selection.value)} 
                                clearable={false} 
                                valueKey="value"
                                labelKey="label" 
                                options={topTierOptions} 
                            />
                        </div>
                        <hr className="tt-hr-divider"/>
                        {/* Load Edit Component */}
                        {topTierIndex != null && <AdminTopTierProductsEdit topTier={topTierSelected} reloadTopTiers={() => this.reloadTopTiers()}/>}
        
                    </Fragment>
                    }
                </Fragment>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        topTiers: state.topTier.topTiers,
        topTiersLoading: state.topTier.topTiersLoading,
    }
}

export default connect(mapStateToProps, {addRoute, setpageTitle, loadTopTiers})(AdminTopTierProducts)


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/products/AdminTopTierProducts.js